import moment from 'moment';
import { BACKEND_DATE_FORMAT } from '../../../config/helpers';

const getDefaultFilterOptionsForSelectedCurrency = ({
  currencyCode,
  filters,
  resultsPerPage,
  siteId,
  defaultSortOrder,
}) => {
  const filterCurrencyData = filters.prices.find((price) => price.currency === currencyCode);

  if (!filterCurrencyData) {
    throw new Error(`Currency data not found for: ${currencyCode}`);
  }

  const defaultFilterOptionsForSelectedCurrency = {
    fromDate: moment().format(BACKEND_DATE_FORMAT),
    page: 1,
    resultsPerPage,
    siteId,
    packageTypes: '',
    sortOrder: defaultSortOrder,
    // min & max range of overall prices from model
    minPrice: filterCurrencyData.minimumPriceValue,
    maxPrice: filterCurrencyData.maximumPriceValue,
    // user selected price from / to within mix/max price range
    priceFrom: filterCurrencyData.minimumPriceValue,
    priceTo: filterCurrencyData.maximumPriceValue,
  };

  // By default, include all tournament IDs
  if (filters?.tournaments?.length) {
    defaultFilterOptionsForSelectedCurrency.tournaments = filters.tournaments.map((t) => t.id);
  }

  return defaultFilterOptionsForSelectedCurrency;
};

export default getDefaultFilterOptionsForSelectedCurrency;
